import type { FC } from 'react'
import { cn } from '@/utils'
import { useCueAfterDropzone } from '../lib/use-cue-after-dropzone'

type CueAfterDropzoneProps = {
  cueId: string
}

export const CueAfterDropzone: FC<CueAfterDropzoneProps> = ({ cueId }) => {
  const { setNodeRef, isOver } = useCueAfterDropzone(cueId)

  return (
    <div
      ref={setNodeRef}
      className={cn(
        'absolute bottom-0 left-0 right-0 z-10',
        // Height defines a dropzone area.
        // Meaning the zone, at which pointer intersection will trigger `isOver` event.
        'h-1/3',
        !isOver && 'pointer-events-none',
      )}
    >
      {isOver && (
        <div className="absolute bottom-1.5 right-0 left-0 h-2 border-b-2 border-blue-500 border-dashed" />
      )}
    </div>
  )
}
